import React from 'react'


export default function ErrorPage({msg}: {msg: string}) {

  return (
    <div className='text-center mt-3'>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{msg}</i>
      </p>
    </div>
  );
}